"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../styles/_brand.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function openBrand(brandId) {
  return function () {
    window.open("".concat(window.location.origin, "/organisation/brand/").concat(brandId), '_blank');
  };
}

function Brand(_ref) {
  var name = _ref.name,
      onSelect = _ref.onSelect,
      updatedAt = _ref.updatedAt,
      imageUrl = _ref.imageUrl,
      selected = _ref.selected,
      canUpdateVideo = _ref.canUpdateVideo,
      brandId = _ref.brandId;
  return /*#__PURE__*/_react.default.createElement(_uiKit.List.CardItem, {
    onClick: onSelect,
    disabled: !canUpdateVideo,
    className: (0, _classnames.default)('brief-brand', {
      'brief-brand--disabled': !canUpdateVideo || selected
    }),
    coverImageProps: {
      imageUrl: imageUrl,
      defaultImageIcon: 'brand'
    },
    smallCoverImage: true,
    selected: selected
  }, /*#__PURE__*/_react.default.createElement(_uiKit.RadioButton, {
    darkMode: true,
    selected: selected
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "brief-brand__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "brief-brand__content__text"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading4: true,
    ellipsisOverflow: true,
    noMargin: "top"
  }, name), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true,
    timestamp: true
  }, (0, _moment.default)(updatedAt).format('MMM D[,] YYYY'))), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    tooltipLabel: "View this brand in a new window",
    tooltipId: "".concat(brandId, "-tooltip"),
    type: "TERTIARY",
    prefix: "linkext",
    onClick: openBrand(brandId),
    className: "brief-brand__content__open"
  })));
}

var _default = /*#__PURE__*/(0, _react.memo)(Brand);

exports.default = _default;